import EventBus from "../common/EventBus";
import { checkLoginStatusAsync } from "../common/utils/utils";

const handler = async (e, cb) => {
  const isLogin = await checkLoginStatusAsync();
  if (!isLogin) {
    EventBus.$dynamic('Login')
    return;
  }
  cb && cb(e);
}
export const remind2LoginDirective = {
  bind: (el, binding) => {
    const { value = true } = binding;
    const isObj = value instanceof Object; // 支持对象形式
    const shouldBind = isObj ? value.shouldBind || true : value;
    const cb = isObj ? value.cb : null;
    if (shouldBind) {
      const clickHandler = (e) => handler(e, cb);
      el._remindHandler = clickHandler
      el.addEventListener("click", clickHandler);
    }
  },
  unbind: (el, binding) => {
    const { value = true } = binding;
    const isObj = value instanceof Object; // 支持对象形式
    const shouldBind = isObj ? value.shouldBind || true : value;
    if (shouldBind) {
      const fn = el._remindHandler
      el.removeEventListener("click", fn);
    }
  },
};